import HttpServices from './HttpServices';

export default class AiInsightsService {
	HttpServices: HttpServices;
	BO_API_URL: string;
	accountId: string;
	useDevOnly: boolean; 
	private devOnly = 'devOnly/'; 
	private idForDevOnly = '4c4eb7b7-ba5b-4f4a-9ee6-a0487b93a678'; 
	// 5c4cfe50-0d91-4af3-bf15-1e1f1c2ae505
	//3a9bf1d0-2c4f-4caf-aad2-06855a8b9ab0
	// '4c4eb7b7-ba5b-4f4a-9ee6-a0487b93a678'; 
	constructor(accId: string,$http:any) {
		this.HttpServices = new HttpServices($http);
		this.accountId = accId;
		if (!window || !(window as any).BEYABLE_env || !(window as any).BEYABLE_env.BO_API_URL) {
			throw 'Configuration [window.BEYABLE_env.BO_API_URL] missing';
		}
		else {
			this.BO_API_URL = `${(window as any).BEYABLE_env.BO_API_URL}`;
		}
		this.useDevOnly = false;
	}
 
	/// DEVONLY
	getAiInsights(locale, callbackSuccess, callbackError) {
		let i18nL = locale;
		i18nL = i18nL.replace(/"/g, '');

		const url = `${this.BO_API_URL}${this.useDevOnly ? this.devOnly : ''}${this.useDevOnly ? this.idForDevOnly : this.accountId}/insight-findings?locale=${i18nL}`;
		this.HttpServices.get(url, callbackSuccess, callbackError);
	}

	getTenantScore(callbackSuccess, callbackError){
		this.HttpServices.get(`${this.BO_API_URL}${this.useDevOnly ? this.devOnly : ''}${this.useDevOnly ? this.idForDevOnly : this.accountId}/account-tenants/score-tenants`,callbackSuccess,callbackError);
	}
	getAvailableDimensions(culture, startDate, endDate, callbackSuccess, callbackError) {
		const prefix = this.useDevOnly ? this.devOnly : '';
		const id = this.useDevOnly ? this.idForDevOnly : this.accountId;
		const url = `${this.BO_API_URL}${prefix}${id}/metrics/summable/available-dimensions?ui-culture=${culture}&startDate=${startDate}&endDate=${endDate}`;
		this.HttpServices.get(url, callbackSuccess, callbackError);
	}
}